'use client';

import { FC } from 'react';
import toast from 'react-hot-toast';

import { useTranslation } from '@/hooks/useTranslations';
import './styles.scss';

interface ToasterProps {
  type: string;
  description: string;
}

const Toaster: FC<ToasterProps> = ({ type, description }) => {
  const { t } = useTranslation();

  return (
    <div className="toast-wrp">
      <div className={`toast-icon-block ${type}`}>
        <i className={`bc-i-${type}`} />
      </div>
      <div className="toast-info-block">
        <p className="toast-title">{t(`${type.toUpperCase()}`)}</p>
        <p className="toast-info-txt">{t(description)}</p>
      </div>

      <div className="toast-close-block">
        <i
          className="bc-i-close"
          onClick={() => {
            toast.dismiss();
          }}
        />
      </div>
    </div>
  );
};

export default Toaster;
